/**
 * 纯 JS 实现的 MD5
 *
 * 小程序没有 crypto 模块，工具集又要求零依赖，所以这里自带一份实现。
 * 参考 RFC 1321，仅处理 UTF-8 字符串。
 */

function toUtf8Bytes(str) {
	const bytes = [];
	for (let i = 0; i < str.length; i++) {
		let code = str.charCodeAt(i);
		if (code < 0x80) {
			bytes.push(code);
		} else if (code < 0x800) {
			bytes.push(0xc0 | (code >> 6), 0x80 | (code & 0x3f));
		} else if (code >= 0xd800 && code <= 0xdbff && i + 1 < str.length) {
			// 处理代理对，避免 emoji 被算错
			const next = str.charCodeAt(i + 1);
			code = 0x10000 + ((code - 0xd800) << 10) + (next - 0xdc00);
			i++;
			bytes.push(
				0xf0 | (code >> 18),
				0x80 | ((code >> 12) & 0x3f),
				0x80 | ((code >> 6) & 0x3f),
				0x80 | (code & 0x3f)
			);
		} else {
			bytes.push(0xe0 | (code >> 12), 0x80 | ((code >> 6) & 0x3f), 0x80 | (code & 0x3f));
		}
	}
	return bytes;
}

function add32(a, b) {
	return (a + b) & 0xffffffff;
}

function rotateLeft(value, shift) {
	return (value << shift) | (value >>> (32 - shift));
}

function cmn(q, a, b, x, s, t) {
	return add32(rotateLeft(add32(add32(a, q), add32(x, t)), s), b);
}

function ff(a, b, c, d, x, s, t) {
	return cmn((b & c) | (~b & d), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
	return cmn((b & d) | (c & ~d), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
	return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
	return cmn(c ^ (b | ~d), a, b, x, s, t);
}

export function md5(input) {
	const bytes = toUtf8Bytes(String(input));
	const bitLength = bytes.length * 8;

	bytes.push(0x80);
	while (bytes.length % 64 !== 56) {
		bytes.push(0);
	}
	// 长度以小端 64 位追加，超过 2^32 位的输入在小程序里不可能出现，高 32 位直接补 0
	for (let i = 0; i < 4; i++) {
		bytes.push((bitLength >>> (8 * i)) & 0xff);
	}
	for (let i = 0; i < 4; i++) {
		bytes.push(0);
	}

	let a = 0x67452301;
	let b = 0xefcdab89;
	let c = 0x98badcfe;
	let d = 0x10325476;

	for (let offset = 0; offset < bytes.length; offset += 64) {
		const x = new Array(16);
		for (let i = 0; i < 16; i++) {
			const j = offset + i * 4;
			x[i] = bytes[j] | (bytes[j + 1] << 8) | (bytes[j + 2] << 16) | (bytes[j + 3] << 24);
		}

		const oldA = a;
		const oldB = b;
		const oldC = c;
		const oldD = d;

		a = ff(a, b, c, d, x[0], 7, -680876936);
		d = ff(d, a, b, c, x[1], 12, -389564586);
		c = ff(c, d, a, b, x[2], 17, 606105819);
		b = ff(b, c, d, a, x[3], 22, -1044525330);
		a = ff(a, b, c, d, x[4], 7, -176418897);
		d = ff(d, a, b, c, x[5], 12, 1200080426);
		c = ff(c, d, a, b, x[6], 17, -1473231341);
		b = ff(b, c, d, a, x[7], 22, -45705983);
		a = ff(a, b, c, d, x[8], 7, 1770035416);
		d = ff(d, a, b, c, x[9], 12, -1958414417);
		c = ff(c, d, a, b, x[10], 17, -42063);
		b = ff(b, c, d, a, x[11], 22, -1990404162);
		a = ff(a, b, c, d, x[12], 7, 1804603682);
		d = ff(d, a, b, c, x[13], 12, -40341101);
		c = ff(c, d, a, b, x[14], 17, -1502002290);
		b = ff(b, c, d, a, x[15], 22, 1236535329);

		a = gg(a, b, c, d, x[1], 5, -165796510);
		d = gg(d, a, b, c, x[6], 9, -1069501632);
		c = gg(c, d, a, b, x[11], 14, 643717713);
		b = gg(b, c, d, a, x[0], 20, -373897302);
		a = gg(a, b, c, d, x[5], 5, -701558691);
		d = gg(d, a, b, c, x[10], 9, 38016083);
		c = gg(c, d, a, b, x[15], 14, -660478335);
		b = gg(b, c, d, a, x[4], 20, -405537848);
		a = gg(a, b, c, d, x[9], 5, 568446438);
		d = gg(d, a, b, c, x[14], 9, -1019803690);
		c = gg(c, d, a, b, x[3], 14, -187363961);
		b = gg(b, c, d, a, x[8], 20, 1163531501);
		a = gg(a, b, c, d, x[13], 5, -1444681467);
		d = gg(d, a, b, c, x[2], 9, -51403784);
		c = gg(c, d, a, b, x[7], 14, 1735328473);
		b = gg(b, c, d, a, x[12], 20, -1926607734);

		a = hh(a, b, c, d, x[5], 4, -378558);
		d = hh(d, a, b, c, x[8], 11, -2022574463);
		c = hh(c, d, a, b, x[11], 16, 1839030562);
		b = hh(b, c, d, a, x[14], 23, -35309556);
		a = hh(a, b, c, d, x[1], 4, -1530992060);
		d = hh(d, a, b, c, x[4], 11, 1272893353);
		c = hh(c, d, a, b, x[7], 16, -155497632);
		b = hh(b, c, d, a, x[10], 23, -1094730640);
		a = hh(a, b, c, d, x[13], 4, 681279174);
		d = hh(d, a, b, c, x[0], 11, -358537222);
		c = hh(c, d, a, b, x[3], 16, -722521979);
		b = hh(b, c, d, a, x[6], 23, 76029189);
		a = hh(a, b, c, d, x[9], 4, -640364487);
		d = hh(d, a, b, c, x[12], 11, -421815835);
		c = hh(c, d, a, b, x[15], 16, 530742520);
		b = hh(b, c, d, a, x[2], 23, -995338651);

		a = ii(a, b, c, d, x[0], 6, -198630844);
		d = ii(d, a, b, c, x[7], 10, 1126891415);
		c = ii(c, d, a, b, x[14], 15, -1416354905);
		b = ii(b, c, d, a, x[5], 21, -57434055);
		a = ii(a, b, c, d, x[12], 6, 1700485571);
		d = ii(d, a, b, c, x[3], 10, -1894986606);
		c = ii(c, d, a, b, x[10], 15, -1051523);
		b = ii(b, c, d, a, x[1], 21, -2054922799);
		a = ii(a, b, c, d, x[8], 6, 1873313359);
		d = ii(d, a, b, c, x[15], 10, -30611744);
		c = ii(c, d, a, b, x[6], 15, -1560198380);
		b = ii(b, c, d, a, x[13], 21, 1309151649);
		a = ii(a, b, c, d, x[4], 6, -145523070);
		d = ii(d, a, b, c, x[11], 10, -1120210379);
		c = ii(c, d, a, b, x[2], 15, 718787259);
		b = ii(b, c, d, a, x[9], 21, -343485551);

		a = add32(a, oldA);
		b = add32(b, oldB);
		c = add32(c, oldC);
		d = add32(d, oldD);
	}

	return [a, b, c, d].map(toHex).join('');
}

function toHex(value) {
	let result = '';
	for (let i = 0; i < 4; i++) {
		const byte = (value >>> (i * 8)) & 0xff;
		result += byte.toString(16).padStart(2, '0');
	}
	return result;
}

export default md5;
